<template>
    <Tabs v-if="tabs.length > 1" :active="activeTab" :tabs="tabs" :onChange="setActiveTab" />

    <Details v-if="activeTab === TransferModalTab.Details" :product="product" />
    <Terms v-if="activeTab === TransferModalTab.Terms" :product="product" />
    <Price v-if="activeTab === TransferModalTab.Price" :product="product" />
</template>
<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent, ref, PropType, computed } from 'vue';
    import { TransferModalTab } from '@/store/general/types';
    import { TransferProduct } from '@/api/Cart/cart.interfaces';
    import { TabButton } from '@ui/components/Tabs/Tabs.interfaces';
    import Tabs from '@ui/components/Tabs/Tabs.vue';
    import Details from './Details/Details.vue';
    import Price from './Price/Price.vue';
    import Terms from './Terms/Terms.vue';

    export default defineComponent({
        name: 'TransferModal',
        methods: { t },
        components: {
            Terms,
            Tabs,
            Details,
            Price,
        },
        props: {
            product: {
                type: Object as PropType<TransferProduct>,
                required: true,
            },
            initialTab: {
                type: String as PropType<TransferModalTab>,
                default: TransferModalTab.Details,
            },
        },
        setup(props) {
            const activeTab = ref<string>(props.initialTab);

            const tabs = computed<TabButton[]>(() => [
                {
                    value: TransferModalTab.Details,
                    label: t({ key: 'shared.details' }),
                },
                {
                    value: TransferModalTab.Terms,
                    label: t({ key: 'shared.terms' }),
                },
                {
                    value: TransferModalTab.Price,
                    label: t({ key: 'shared.price' }),
                },
            ]);

            const setActiveTab = (value: string) => {
                activeTab.value = value;
            };

            return {
                tabs,
                activeTab,
                setActiveTab,
                TransferModalTab,
            };
        },
    });
</script>
